import { createI18n } from 'vue-i18n'

/** @ts-ignore-next-line */
import en from '../../lang/en.json'
/** @ts-ignore-next-line */
import { messageCompiler } from './compiler.ts'

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  fallbackLocale: 'en',
  messageCompiler: messageCompiler,
  // Pre-load English by default to prevent flickers
  messages: {
    en,
  },
})

export async function setLocale(locale: string) {
  const messages = await import(`../../lang/${locale}.json`)

  /** @ts-ignore-next-line */
  i18n.global.locale.value = locale
  i18n.global.setLocaleMessage(locale, messages.default)
}

export const getActiveLanguage = () => i18n.global.locale.value

export const t = i18n.global.t
export const trans = t
